import * as api from '../_utils/api';

export class ArchivistsApi {

    static async getArchivistProfile(archivistId: number): Promise<any> {
        return api._get(`archivists/get/${archivistId}`);
    }
}
